import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import app from './containers/App/reducer';
import home from './containers/HomePage/reducer';

const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  app,
  home,
});

export default rootReducer;
